import React, { Component } from 'react';
import { Menu, Tooltip } from 'antd';
// import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import s from './style.module.less';
import { NavLink } from 'react-router-dom';
import withRouter from '../withRouter';
import ToolTipMenu from './ToolTipMenu';
import { Display } from '../Display/Display';

import MyIcon from '../MyIcon/MyIcon';
import classnames from 'classnames';
import { handleGetCustomLogin } from '@/api/login';
@inject('store')
@observer
class MainMenu extends Component {
    state = {
        curHoverId: null, //划过菜单 变换icon
        login_image: null
    };
    componentDidMount() {
        // 登录页自定义配置
        handleGetCustomLogin().then((res) => {
            if (res.success) {
                this.setState({
                    login_image: res.data?.page_config?.login_checked === 0 ? res.data?.page_config?.login_image : null
                });
            }
        });
    }

    onClickHome = () => {
        const { menu } = this.props.store;
        menu.setMenuState({
            outSelectMenu: {
                id: 'home',
                name: '首页',
                children: [],
                resource_path: '/'
            },
            subSelectMenu: {},
            subMenuOpenKeys: [],
            curRouteInfo: {
                id: 'home',
                name: '首页'
            }
        });
        this.props.navigate('/');
    };
    //点击一级菜单
    onClickOutMenu = (menuInfo) => {
        let defaultSecondMenu = {},
            routePath = '',
            defaultRouteInfo = {};
        if (menuInfo.id !== 'home') {
            defaultSecondMenu = menuInfo.children[0] || {};
            defaultRouteInfo = defaultSecondMenu.children ? defaultSecondMenu.children[0] : {};
        } else {
            defaultRouteInfo = menuInfo;
        }
        //外链且新页面打开
        if (defaultRouteInfo.resource_source === 4 && defaultRouteInfo.new_tab === 1) {
            window.open(defaultRouteInfo.resource_path);
            return false;
        }
        if (defaultRouteInfo.resource_source === 2) {
            routePath = `tenant/view/${defaultRouteInfo.page_key}`;
        } else {
            routePath = defaultRouteInfo.resource_path;
        }
        this.props.navigate(routePath);
        // menu.setMenuState({
        //     outSelectMenu: menuInfo,
        //     subSelectMenu: defaultRouteInfo,
        //     subMenuOpenKeys: [defaultSecondMenu.id]
        // });
    };

    onMouseEnter = (id) => {
        this.setState({
            curHoverId: id
        });
    };

    resetHoverId = () => {
        this.setState({
            curHoverId: null
        });
    };

    render() {
        const { menu } = this.props.store;

        return (
            <div style={{ overflowY: 'auto', height: '100vh', width: menu.collapsed ? '64px' : '128px', position: 'relative' }}>
                <div className={`${s.menuAll} menuAll`}>
                    <div className={s.logo}>
                        {this.state.login_image && <img src={this.state.login_image} />}
                    </div>
                    <Menu selectedKeys={[toJS(menu.menuState.outSelectMenu).id]}>
                        <Menu.Item
                            onMouseEnter={() => {
                                this.onMouseEnter('home');
                            }}
                            onMouseLeave={this.resetHoverId}
                            key={'home'}
                            onClick={() => {
                                this.onClickHome();
                            }}
                        >
                            <NavLink to={'/'}>
                                <div className={classnames('menu-text', menu.collapsed ? 'menu-text-collapsed' : '')}>
                                    <MyIcon
                                        className={'menu-icon'}
                                        type={
                                            menu.menuState.outSelectMenu.id === 'home' || this.state.curHoverId === 'home'
                                                ? 'icon-home-a'
                                                : 'icon-home'
                                        }
                                    ></MyIcon>

                                    <Display show={!menu.collapsed}>
                                        <span className={s['menu-name']}> 首页</span>
                                    </Display>
                                </div>
                            </NavLink>
                        </Menu.Item>
                        {menu.menus.map((topMenu) => (
                            <Menu.Item
                                onMouseEnter={() => {
                                    this.onMouseEnter(topMenu.id);
                                }}
                                onMouseLeave={this.resetHoverId}
                                key={topMenu.id || topMenu.resource_name}
                                onClick={() => {
                                    this.onClickOutMenu(topMenu);
                                }}
                            >
                                {/* 当前的菜单--划过不显示tooltip */}
                                <Display show={topMenu.id === menu.menuState.outSelectMenu.id && !menu.collapsed}>
                                    <div className={classnames('menu-text', menu.collapsed ? 'menu-text-collapsed' : '')}>
                                        <Display show={topMenu.resource_icon}>
                                            <MyIcon className={'menu-icon'} type={`${topMenu.resource_icon}-a`}></MyIcon>
                                        </Display>
                                        <Display show={!menu.collapsed}>
                                            <span className={s['menu-name']}> {topMenu.name || topMenu.resource_name}</span>
                                        </Display>
                                    </div>
                                </Display>
                                {/* 划过显示tooltip */}
                                <Display show={topMenu.id !== menu.menuState.outSelectMenu.id || menu.collapsed}>
                                    <Tooltip
                                        overlayClassName={s['tool-tip-menu']}
                                        mouseEnterDelay={0.3}
                                        key={topMenu.id || topMenu.resource_name}
                                        placement="rightTop"
                                        title={<ToolTipMenu curRouteInfo={menu.menuState.curRouteInfo} menu={topMenu}></ToolTipMenu>}
                                    >
                                        <div className={classnames('menu-text', menu.collapsed ? 'menu-text-collapsed' : '')}>
                                            <Display show={topMenu.resource_icon}>
                                                <MyIcon
                                                    className={'menu-icon'}
                                                    type={this.state.curHoverId === topMenu.id ? `${topMenu.resource_icon}-a` : topMenu.resource_icon}
                                                ></MyIcon>
                                            </Display>
                                            <Display show={!menu.collapsed}>
                                                <span className={s['menu-name']}> {topMenu.name || topMenu.resource_name}</span>
                                            </Display>
                                        </div>
                                    </Tooltip>
                                </Display>
                            </Menu.Item>
                        ))}
                    </Menu>
                </div>
            </div>
        );
    }
}

export default withRouter(MainMenu);
